<template>
  <div>
    <div class="dialogContainer">
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="90px"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            v-model="handleForm.title"
            name="title"
            placeholder="请输入标题"
            maxlength="100"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input
            v-model="handleForm.author"
            name="slogan"
            maxlength="20"
            placeholder="请输入作者"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="资讯类型" prop="typeId">
          <el-cascader
            ref="myCascader"
            v-model="handleForm.typeId"
            placeholder="请选择"
            :options="CascaderOptions"
            :props="{ multiple: true,value: 'id',label: 'name',emitPath:false}"
            @change="handleChange"
          />
        </el-form-item>

        <el-form-item label=" 图片" prop="photoUrl">
          <div class="handle-form-input imguploadrigth">
            <span>推荐尺寸200x200</span>
            <upload-file
              :props="{serveCode:'news_content_pic',accept:'.png, .jpg, .jpeg',type:['image/jpeg','image/gif','image/png']}"
              @uploadSucess="uploadSucessFn"
            >
              <el-button size="small" type="primary">
                点击上传
              </el-button>
            </upload-file>
          </div>
          <div class="picture-wrapper">
            <img :src="handleForm.photoUrl" alt height="100%">
          </div>
        </el-form-item>
        <el-form-item label="正文" prop="content">
          <div class="handle-form-input">
            <Editor :editor-content="handleForm.content" serve-code="news_content_pic" :num-img-max="200" @editorChange="editorChangeFn" @editorChangeText="editorChangeTextFn" />
          </div>
        </el-form-item>
        <!-- <el-form-item label="备注" prop="remark">
          <el-input
            v-model="handleForm.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入备注"
            class="handle-form-input"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddSubject"
      >
        {{ ajaxLoading?'Loading':'立即发布' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// 获取API
import {
  demandsensitivewordsCheck
} from '@/api/systemManage/sensitiveManage';
import { newsTypTree, newsAdd, newsDetails, newsEidt } from '@/api/productOperation/mrDesk/news';
import { getToken } from '@/utils/auth';
export default {
  name: 'DialogInfo',
  props: {
    type: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    const validatorEditorText = (rule, value, callback) => {
      if (!value) {
        callback(new Error('资讯正文不能为空'));
      } else {
        callback();
      }
    };
    const validatortName = (rule, value, callback) => {
      // const pattern = new RegExp(/^[\u4e00-\u9fa5-_a-zA-Z0-9\uff1f\uff01\u3002\.\?\!]+$/);
      if (!value) {
        callback(new Error('标题不能为空'));
      } else {
        var content = {
          content: value
        };
        demandsensitivewordsCheck(content).then(response => {
          if (response.data && response.data.isChoose) {
            callback(response.data.badword);
          } else {
            callback();
          }
        });
      }
    };
    return {
      fileList: [],
      ajaxLoading: false,
      CascaderOptions: [],
      uploadHeader: {},
      // 操作表单
      handleForm: {
        type: '',
        id: '',
        title: '',
        author: '',
        photoUrl: '',
        photoPath: '',
        content: '',
        editorText: '',
        remark: '',
        typeId: []
      },
      handleRules: {
        title: [
          { required: true, message: '资讯标题不能为空', trigger: 'blur' },
          { trigger: 'blur', validator: validatortName }
        ],
        photoUrl: [
          { required: true, message: '资讯图片不能为空', trigger: 'blur' }
        ],
        typeId: [
          { required: true, message: '资讯类型不能为空', trigger: 'blur' }
        ],
        content: [
          { trigger: 'change', validator: validatorEditorText }
        ]
      }
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['newscontentsUrl'])
  },
  watch: {
    type: {
      handler(val) {
        if (val && val === 'edit') {
          this.getConsultingDetails(this.id);
        } else {
          this.handleForm = { type: '',
            id: '',
            title: '',
            author: '',
            photoUrl: '',
            photoPath: '',
            content: '',
            remark: '',
            typeId: [] };
        }
      }
    }
  },
  mounted() {
    this.getConsultingTypTree();
    this.initUploadData();
    if (this.type === 'edit') {
      this.getConsultingDetails(this.id);
    } else {
      this.handleForm = { type: '',
        id: '',
        title: '',
        author: '',
        photoUrl: '',
        photoPath: '',
        content: '',
        remark: '',
        typeId: [] };
    }
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
    },
    // 获取详情
    getConsultingDetails(val) {
      var option = {
        id: val
      };
      newsDetails(option)
        .then(res => {
          this.handleForm = res.data;
          var arr = [];
          // this.handleForm.newsTypeSimpleVOS.forEach((item) => {
          //   var res = [];
          //   this.recursionArr(item.id, this.CascaderOptions, res);
          //   arr.push(res);
          // });
          if (this.handleForm.newsTypeSimpleVOS.length > 0) {
            arr = this.handleForm.newsTypeSimpleVOS.map(x => x.id);
          }
          this.handleForm.typeId = arr;
        });
    },
    // 递归数组获取子集及父集
    recursionArr(id, arrOptions, arr) {
      var resArr = [];
      recursionArrfn(id, arrOptions);
      function recursionArrfn(id, arrOptions = []) {
        var allArr = arrOptions; // 深拷贝
        var tmp = 0;
        for (let i = 0; i < allArr.length; i++) {
          const v = allArr[i];
          if (v.id === id) {
            arr.push(v.id);
            return v.id;
          }
          if (v.children && v.children.length > 0) {
            tmp = recursionArrfn(id, v.children);
          }
          if (tmp && tmp !== 0) {
            arr.push(v.id);
            return v.id;
          }
        }
      }
      return resArr;
    },

    // 获取资源类型树
    getConsultingTypTree() {
      newsTypTree()
        .then(res => {
          this.CascaderOptions = res.data;
        });
    },
    // 资源类型树变化
    handleChange(val) {
      this.handleForm.typeId = val;
    },
    // 编辑文本框变化
    editorChangeFn(val) {
      this.handleForm.content = val;
    },
    editorChangeTextFn(val) {
      this.handleForm.remark = val;
      this.handleForm.editorText = val;
    },

    uploadSucessFn(val) {
      this.handleForm.photoPath = val.relativePath;
      this.handleForm.photoUrl = val.absolutePath;
    },
    // 新增
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var content = {
            content: this.handleForm.editorText
          };
          demandsensitivewordsCheck(content).then(response => {
            if (response.data && response.data.isChoose) {
              this.$message({
                type: 'warning',
                message: response.data.badword
              });
              return;
            } else {
              this.ajaxLoading = true;
              if (this.type === 'add') { // 添加
                var option = {
                  remark: this.handleForm.remark,
                  title: this.handleForm.title,
                  author: this.handleForm.author,
                  photoUrl: this.handleForm.photoUrl,
                  photoPath: this.handleForm.photoPath,
                  content: this.handleForm.content,
                  newsTypeIds: this.handleForm.typeId
                };

                newsAdd(option)
                  .then(res => {
                    this.$emit('closeDialog');
                    this.ajaxLoading = false;
                  }).catch(err => {
                    this.ajaxLoading = false;
                    console.log(err);
                  });
              } else { // 编辑
                var option1 = {
                  id: this.id,
                  remark: this.handleForm.remark,
                  title: this.handleForm.title,
                  author: this.handleForm.author,
                  photoUrl: this.handleForm.photoUrl,
                  photoPath: this.handleForm.photoPath,
                  content: this.handleForm.content,
                  newsTypeIds: this.handleForm.typeId
                };
                newsEidt(option1)
                  .then(res => {
                    this.$emit('closeDialog');
                    this.ajaxLoading = false;
                  }).catch(err => {
                    this.ajaxLoading = false;
                    console.log(err);
                  });
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialogContainer {
  // height: 640px;
  // overflow-y: auto;
}
.upload-picture {
  float: right;
}
.handle-form-input {
  width: 96%;
}
.picture-wrapper {
  width: 96%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.dialog-footer {
  text-align: right;
  padding-top: 20px;
  box-shadow: rgba(153, 153, 153, 0.2) 0 -7px 5px -5px;
}
</style>
